import React, { Component } from 'react';
import parse from 'html-react-parser';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, MenuItem, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import TablePagination from '@material-ui/core/TablePagination';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Calendar from './index';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { DatePicker } from '@material-ui/pickers';
import { myFormatDate2 } from '../../../@jumbo/utils/commonHelper';
import FormControl from '@material-ui/core/FormControl';
import MuiAlert from '@material-ui/lab/Alert';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media screen and (max-width: 800px)': {
    width: '95%',
  },
  '@media screen and (min-width: 800px)': {
    width: 600,
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function MyAlert(props) {
  return <MuiAlert elevation={6} variant="outlined" {...props} />;
}

const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
  table: {
    maxHeight: '50%',
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function getMyDate(prop) {
  var md = new Date(prop);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
}

class ModifyRoom extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.checkDates = this.checkDates.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      type: -1,
      rooms: 0,
      arrival: '',
      departure: '',
      currentPrice: '',
      newPrice: '',
      adults: 0,
      children: 0,
      childAge2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      available: 0,
      childAge: '',
    };
  }

  checkDates() {
    if (this.state.rooms < 0) return;
    if (getMyDate(this.state.arrival) >= getMyDate(this.state.departure)) return;
    if (this.state.adults == '') return;
    if (this.state.childre == '') return;
    if (this.state.rooms == '') return;
    //this.props.moveFolio(this.state.folioId);
    const token = localStorage.getItem('token');
    var pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;
    const senddata = {
      Action: 'modifyInfo',
      token: token,
      Data: {
        reservationRoomId: this.props.resRoom.brid,
        reservationId: this.props.resRoom.id,
        rooms: this.state.rooms,
        arrival: getMyDate(this.state.arrival),
        departure: getMyDate(this.state.departure),
        adults: this.state.adults,
        children: this.state.children,
        rate_id: this.props.resRoom.rate_id,
        meal_plan_id: this.props.resRoom.meal_plan_id,
        childAge: this.state.childAge2.slice(0, this.state.children).toString(),
      },
    };
    axios.post(pmsUrl, senddata).then(res => {
      //  this.props.doRefresh();
      //   alert(JSON.stringify(res.data));
      this.setState({ newPrice: res.data.newPrice, available: res.data.available });
    });
  }
  handleClickOpen() {
    //  setOpen(true);
  }

  handleChange(name, value, index = -1) {
    if (name == 'childAge') {
      this.setState(
        prevState => {
          var va = prevState.childAge2;
          va[index] = value;
          return { childAge2: va, changed: true };
        },
        () => {
          if (name != 'newPrice') this.checkDates();
        },
      );
    } else
      this.setState({ [name]: value, changed: true }, () => {
        if (name != 'newPrice') this.checkDates();
      });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.open != this.props.open) {
      this.setState(
        {
          rooms: this.props.resRoom.rooms,
          arrival: this.props.resRoom.checkin,
          departure: this.props.resRoom.checkout,
          currentPrice: this.props.resRoom.price,
          adults: this.props.resRoom.adults,
          children: this.props.resRoom.children,
          childAge: this.props.resRoom.childAge,
        },
        () => {
          this.checkDates();
        },
      );
    }
  }

  handleClose() {
    this.props.setState({ modifyRoomVisible: false });
    //  setOpen(false);
  }

  handleSelect() {
    if (this.state.rooms < 0) return;
    if (getMyDate(this.state.arrival) >= getMyDate(this.state.departure)) return;
    //this.props.moveFolio(this.state.folioId);
    const token = localStorage.getItem('token');
    var pmsUrl = `https://secure.webbookingpro.com/api/pms.php`;
    const senddata = {
      Action: 'modifyreservation',
      token: token,
      Data: {
        reservationRoomId: this.props.resRoom.brid,
        reservationId: this.props.resRoom.id,
        rooms: this.state.rooms,
        arrival: getMyDate(this.state.arrival),
        departure: getMyDate(this.state.departure),
        adults: this.state.adults,
        children: this.state.children,
        childAge: this.state.childAge2.slice(0, this.state.children).toString(),
        newPrice: this.state.newPrice,
      },
    };
    axios.post(pmsUrl, senddata).then(res => {
      if (this.props.setState2 != null) this.props.setState2({ resDetailsVisible: false });
      if (this.props.setState2 != null) this.props.setState2({ lastEvents: [], running2: false });
      this.props.doRefresh();
      //if (this.props.doRefresh != null) this.props.doRefresh();
      this.props.setState({ modifyRoomVisible: false });
      if (this.props.doRefresh2 != null) this.props.doRefresh2();
    });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          anchorEl={this.props.anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}>
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  id="type"
                  label=<IntlMessages id="res.rooms" />
                  value={this.state.rooms}
                  fullWidth
                  disabled={false}
                  onChange={event => this.handleChange('rooms', event.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={6} xl={6}>
                <TextField
                  id="type"
                  label=<IntlMessages id="res.adults" />
                  value={this.state.adults}
                  fullWidth
                  disabled={false}
                  onChange={event => this.handleChange('adults', event.target.value)}
                />
              </Grid>
              <Grid item xs={6} md={6} xl={6}>
                <TextField
                  id="type"
                  label=<IntlMessages id="res.children" />
                  value={this.state.children}
                  fullWidth
                  disabled={false}
                  onChange={event => this.handleChange('children', event.target.value)}
                />
                {this.state.children > 0 && (
                  <Box className={classes.cardContentInner2}>
                    <Typography component="label" className={classes.title}>
                      <IntlMessages id="childAges" />
                      <br />
                    </Typography>
                    {Array(parseInt(this.state.children))
                      .fill()
                      .map((_, ci) => (
                        <TextField
                          id="priceModel"
                          name="priceModel"
                          select
                          variant="outlined"
                          size="small"
                          margin="small"
                          className={classes.currency}
                          value={this.state.childAge2[ci]}
                          onChange={event => this.handleChange('childAge', event.target.value, ci)}>
                          {Array(18)
                            .fill()
                            .map((_, idx) => (
                              <MenuItem value={idx}>{idx}</MenuItem>
                            ))}
                        </TextField>
                      ))}
                  </Box>
                )}
              </Grid>

              <Grid item xs={6} md={6} xl={6}>
                <FormControl variant="filled" className={classes.formControl}>
                  <DatePicker
                    variant="inline"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    margin="normal"
                    id="date1"
                    name="date1"
                    label={<IntlMessages id="res.arrival" />}
                    autoOk="true"
                    value={this.state.arrival}
                    onChange={date => {
                      this.setState({ arrival: date }, () => {
                        this.checkDates();
                        //if (cloudUser == 0) this.checkOffers();
                      });
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6} xl={6}>
                <FormControl variant="filled" className={classes.formControl}>
                  <DatePicker
                    variant="inline"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    margin="normal"
                    id="date1"
                    name="date1"
                    label={<IntlMessages id="res.departure" />}
                    autoOk="true"
                    value={this.state.departure}
                    onChange={date => {
                      this.setState({ departure: date }, () => {
                        this.checkDates();
                        //if (cloudUser == 0) this.checkOffers();
                      });
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={6} md={6} xl={6}>
                <TextField
                  id="type"
                  label=<IntlMessages id="res.guestPrice" />
                  value={this.state.currentPrice}
                  fullWidth
                  disabled={true}
                />
              </Grid>
              <Grid item xs={6} md={6} xl={6}>
                <TextField
                  id="type"
                  label=<IntlMessages id="cockpit.price" />
                  value={this.state.newPrice}
                  fullWidth
                  disabled={false}
                  onChange={event => this.handleChange('newPrice', event.target.value)}
                />
              </Grid>

              {this.state.available == 0 && (
                <Grid item xs={12}>
                  <MyAlert severity="warning">
                    <IntlMessages id="_NO_AVAILABLE_ROOMS" />
                  </MyAlert>
                </Grid>
              )}
              {this.state.newPrice == 0 && (
                <Grid item xs={12}>
                  <MyAlert severity="warning">
                    <IntlMessages id="cockpit.noPrice" />
                  </MyAlert>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.myButton}
                  onClick={() => this.handleClose()}
                  fullWidth>
                  <IntlMessages id="findClient.cancel" />
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.myButton}
                  onClick={() => this.handleSelect()}
                  fullWidth>
                  <IntlMessages id="buttonSet" />
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(ModifyRoom));
